import apolloClient from "src/shared/utilities/graphql/apolloClient";

import {
  CHECK_SHOWING_TIME_SCHEDULING_URL_EXPIRATION,
  GENERATE_SHOWING_TIME_AGENT_CONFIGURATION_URL,
  GENERATE_SHOWING_TIME_LISTING_CONFIGURATION_URL,
  GENERATE_SHOWING_TIME_SCHEDULING_URL
} from "../graphql/queries";

const checkExpiredPeriod = async url => {
  const { data } = await apolloClient.query({
    query: CHECK_SHOWING_TIME_SCHEDULING_URL_EXPIRATION,
    variables: {
      url
    },
    fetchPolicy: "network-only"
  });

  return !!data?.check_showing_time_scheduling_url_expiration?.expired;
};

const generateSchedulingUrl = async saleId => {
  const { data } = await apolloClient.query({
    query: GENERATE_SHOWING_TIME_SCHEDULING_URL,
    variables: {
      saleId
    },
    fetchPolicy: "network-only"
  });

  return data.generate_showing_time_scheduling_url.url;
};

const generateListingConfigurationUrl = async saleId => {
  try {
    const { data } = await apolloClient.query({
      query: GENERATE_SHOWING_TIME_LISTING_CONFIGURATION_URL,
      variables: {
        saleId
      }
    });
    return data.generate_showing_time_listing_configuration_url.url;
  } catch (error) {
    return null;
  }
};

const generateAgentConfigurationUrl = async () => {
  try {
    const { data } = await apolloClient.query({
      query: GENERATE_SHOWING_TIME_AGENT_CONFIGURATION_URL
    });
    return data.generate_showing_time_agent_configuration_url.url;
  } catch (error) {
    return null;
  }
};

export default {
  checkExpiredPeriod,
  generateSchedulingUrl,
  generateListingConfigurationUrl,
  generateAgentConfigurationUrl
};
